import { getFormatsDropdown } from "../helpers/toolbar";
import { ISpreadsheetConfig } from "../types";
import locale from "./../locales/en";

export function getMenuStruct(config: ISpreadsheetConfig) {
	return [
		{
			id: "file",
			open: true,
			value: locale.file,
			items: [
				{
					id: "import",
					value: locale.importAs,
					icon: "dxi dxi-file-import",
					items: [
						{
							id: "import-xlsx",
							value: "Microsoft Excel(.xlsx)",
							icon: "dxi dxi-file-excel",
						},
					],
				},
				{
					id: "download",
					value: locale.downloadAs,
					icon: "dxi dxi-file-export",
					items: [
						{
							id: "export-xlsx",
							value: "Microsoft Excel(.xlsx)",
							icon: "dxi dxi-file-excel",
						},
					],
				},
			],
		},
		{
			id: "edit",
			value: locale.edit,
			items: [
				{ id: "undo", value: locale.undo, icon: "dxi dxi-undo" },
				{ id: "redo", value: locale.redo, icon: "dxi dxi-redo" },
				{ type: "separator" },
				{ id: "lock", value: locale.lockCell, icon: "dxi dxi-key" },
				{ type: "separator" },
				{
					id: "clear",
					value: locale.clear,
					icon: "dxi dxi-eraser",
					items: [
						{
							id: "clear-value",
							value: locale.clearValue,
						},
						{
							id: "clear-styles",
							value: locale.clearStyles,
						},
						{
							id: "clear-all",
							value: locale.clearAll,
						},
					],
				},
			],
		},
		{
			id: "insert",
			value: locale.insert,
			items: [
				{
					id: "columns",
					value: locale.columns,
					icon: "dxi dxi-table-column",
					items: [
						{
							id: "add-col",
							value: locale.addColumn,
							icon: "dxi dxi-table-column-plus-before",
						},
						{
							id: "remove-col",
							value: locale.removeColumn,
							icon: "dxi dxi-table-column-remove",
						},
					],
				},
				{
					id: "rows",
					value: locale.rows,
					icon: "dxi dxi-table-row",
					items: [
						{
							id: "add-row",
							value: locale.addRow,
							icon: "dxi dxi-table-row-plus-before",
						},
						{
							id: "remove-row",
							value: locale.removeRow,
							icon: "dxi dxi-table-row-remove",
						},
					],
				},
				{
					id: "link",
					type: "navItem",
					icon: "dxi dxi-link-variant",
					value: `${locale.insert} ${locale.link.toLowerCase()}`,
				},
			],
		},
		{
			id: "configuration",
			value: locale.format,
			items: [
				{
					id: "font-weight-bold",
					value: locale.bold,
					icon: "dxi dxi-format-bold",
				},
				{
					id: "font-style-italic",
					value: locale.italic,
					icon: "dxi dxi-format-italic",
				},
				{
					id: "text-decoration-underline",
					value: locale.underline,
					icon: "dxi dxi-format-underline",
				},
				{
					id: "text-decoration-line-through",
					value: locale.strikethrough,
					icon: "dxi dxi-format-strikethrough",
				},
				{ type: "separator" },
				{
					id: "halign",
					value: locale.halign,
					items: [
						{
							id: "halign-left",
							value: locale.left,
							twoState: true,
							group: "halign",
							icon: "dxi dxi-format-align-left",
						},
						{
							id: "halign-center",
							value: locale.center,
							twoState: true,
							group: "halign",
							icon: "dxi dxi-format-align-center",
						},
						{
							id: "halign-right",
							value: locale.right,
							twoState: true,
							group: "halign",
							icon: "dxi dxi-format-align-right",
						},
					],
				},
				{
					id: "valign",
					value: locale.valign,
					items: [
						{
							id: "valign-top",
							value: locale.top,
							twoState: true,
							group: "valign",
							icon: "dxi dxi-format-vertical-align-top",
						},
						{
							id: "valign-center",
							value: locale.center,
							twoState: true,
							group: "valign",
							icon: "dxi dxi-format-vertical-align-center",
						},
						{
							id: "valign-bottom",
							value: locale.bottom,
							twoState: true,
							group: "valign",
							icon: "dxi dxi-format-vertical-align-bottom",
						},
					],
				},
				{
					id: "multiline",
					value: locale.multiline,
					items: [
						{
							id: "multiline-clip",
							group: "multiline",
							twoState: true,
							value: locale.clip,
							icon: "dxi dxi-format-text-wrapping-clip",
						},
						{
							id: "multiline-wrap",
							group: "multiline",
							twoState: true,
							value: locale.wrap,
							icon: "dxi dxi-format-text-wrapping-wrap",
						},
					],
				},
				{
					id: "format",
					type: "navItem",
					value: locale.format,
					items: getFormatsDropdown(config),
				},
				{
					id: "merge",
					type: "navItem",
					// icon: "dxi dxi-format-align-left", //[TODO] add new icons
					value: locale.merge,
					tooltip: locale.merge,
				},
			],
		},
		{
			id: "data",
			value: locale.data,
			items: [
				{
					id: "validation",
					value: locale.validation,
					icon: "dxi dxi-table-check",
				},
				{
					id: "search",
					value: locale.search,
					icon: "dxi dxi-magnify",
				},
				{
					id: "filter",
					value: locale.filter,
					icon: "dxi dxi-filter-variant",
				},
				{
					id: "sort",
					value: locale.sort,
					icon: "dxi dxi-format-line-spacing",
					items: [
						{
							id: "asc-sort",
							value: locale.ascSort,
							icon: "dxi dxi-sort-variant dhx-sort-acs",
						},
						{
							id: "desc-sort",
							value: locale.descSort,
							icon: "dxi dxi-sort-variant",
						},
					]
				}
			],
		},
		{
			id: "help",
			value: locale.help,
		},
	];
}
